import { render, staticRenderFns } from "./AccessContent.vue?vue&type=template&id=61dae07c&scoped=true"
import script from "./AccessContent.vue?vue&type=script&lang=ts"
export * from "./AccessContent.vue?vue&type=script&lang=ts"
import style0 from "./AccessContent.vue?vue&type=style&index=0&id=61dae07c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61dae07c",
  null
  
)

export default component.exports